import { render, staticRenderFns } from "./industry_environment.vue?vue&type=template&id=74bfd911&scoped=true"
import script from "./industry_environment.vue?vue&type=script&lang=js"
export * from "./industry_environment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfd911",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74bfd911')) {
      api.createRecord('74bfd911', component.options)
    } else {
      api.reload('74bfd911', component.options)
    }
    module.hot.accept("./industry_environment.vue?vue&type=template&id=74bfd911&scoped=true", function () {
      api.rerender('74bfd911', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/industry/industry_environment.vue"
export default component.exports